import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/startpage-logged-out/language-switcher/src/assets/illustration-mobile.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')